<template>
<div>
    <Header />
    <Footer />
    <main id="sub" class="about">
        <div class="main-slider-wrap">
            <div class="main-slider">
                <div class="swiper aboutSwiper">
                    <div class="swiper-wrapper" v-if="bannerList.length > 0">
                        <div class="swiper-slide" v-for="(banner, idx) in bannerList" :key="idx" @click="goToUrl(banner)">
                            <div class="about-swiper-content">
                                <dl>
                                    <dt>{{banner.title}}</dt>
                                    <dd>{{banner.sub_title}}</dd>
                                </dl>
                            </div>
                            <figure>
                                <img :src="banner.image_url">
                            </figure>
                        </div>
                    </div>
                    <div class="swiper-wrapper" v-else>
                        <div class="swiper-slide"></div>
                        <div class="swiper-slide"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="about-content-wrap">
            <div class="inr">
                <ul class="about-content-lists">
                    <li class="about-content-list" v-for="(floor, idx) in floorList" :key="idx">
                        <dl>
                            <dt>{{floor.title}}</dt>
                            <dd>{{floor.sub_title}}</dd>
                        </dl>
                        <figure>
                            <img :src="floor.image_url">
                        </figure>
                    </li>
                </ul>
            </div>
        </div>
    </main>
</div>
</template>

<script>
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";

export default {
    components: {
        Header,
        Footer
    },
    data() {
        return {
            bannerList: [],
            floorList: []
        };
    },
    async mounted() {
        try {
            const bannerResult = await this.axios.get(`/banner/floor`);
            this.bannerList = bannerResult.data.result;

            const floorResult = await this.axios.get(`/floor`);
            this.floorList = floorResult.data.result;

            this.$nextTick(() => {
                new Swiper(".aboutSwiper", {
                    slidesPerView: 1.1,
                    spaceBetween: 5,
                    centeredSlides: true,
                    autoplay: true,
                    loop: true,
                    loopFillGroupWithBlank: false
                });
            });
        } catch (err) {
            console.log(err);
        }
    },
    methods: {
        goToUrl(banner) {
            if (!banner.target_url) {
                return;
            }
            if (banner.target_type === "_blank") {
                window.open(banner.target_url, "_blank");
            } else {
                this.$router.push({
                    path: banner.target_url
                });
            }
        }
    }
};
</script>
